import { useContext, useEffect, useState } from 'react'
import AssistedBooking from '../../common/components/assistedBooking/index'
import AssistedStyles from '../../common/components/assistedBooking/theme1/index.module.css'
import AssistedStylestwo from '../../common/components/assistedBooking/theme4/index.module.css'
import AssistedMobile from '../../common/components/assistedBooking/theme4/mobile.module.css'
import AuthContext from 'store/auth-context'
import Countrystyles from '../../common/components/CountryDropdown/theme1/index.module.css'
import Footer from '@/commonComponents/footer/index'
import Head from 'next/head'
import Header from '@/commonComponents/header/index'
import HideHeader from 'store/hideHeader'
import ISDstyles from '../../common/components/IsdCountryDropdown/theme1/index.module.css'
import ISDstylesTheme5 from '../../common/components/IsdCountryDropdown/theme5/index.module.css'
import ISDstylesTheme7 from '../../common/components/IsdCountryDropdown/theme7/index.module.css'
import LoginComponent from '../../common/components/login/index'
import MobileHeader from '@/commonComponents/mobileHeader/index'
import MobileSubFooter from '@/commonComponents/mobileSubFooter/index'
import MobileSubHeader from '@/commonComponents/mobileSubHeader/index'
import ModalPopupComponent from '@/commonComponents/ModalPopupComponent/ModalPopupComponent'
import SectionContainer from './SectionContainer'
import cf from '../../common/lib/utils/common'
import { checkregistertoken } from '../lib/checkregistertoken'
import { checksession } from '../../common/lib/checksession'
import configUrl from '../../config/config.json'
import cssfilefooter from '../../common/components/footer/footer1/index.module.css'
import cssfilefootertheme2 from '../../common/components/footer/footer2/index.module.css'
import cssfilefootertheme4 from '../../common/components/footer/footer4/index.module.css'
import cssfilefootertheme5 from '../../common/components/footer/footer5/index.module.css'
import cssfilefootertheme7 from '../../common/components/footer/footer7/index.module.css'
import cssfilefootertheme8 from '../../common/components/footer/footer8/index.module.css'
import cssfilefootertheme9 from '../../common/components/footer/footer9/index.module.css'
import cssfilefootertheme10 from '../../common/components/footer/footer10/index.module.css'
import cssfilefootertheme11 from '../../common/components/footer/footer11/index.module.css'
import cssfilefootertheme12 from '../../common/components/footer/footer12/index.module.css'
import cssfilefootertheme13 from '../../common/components/footer/footer13/index.module.css'

import cssfileheader from '../../common/components/header/theme1/index.module.css'
import cssfileheadertheme2 from '../../common/components/header/theme2/index.module.css'
import cssfileheadertheme4 from '../../common/components/header/theme4/index.module.css'
import cssfileheadertheme5 from '../../common/components/header/theme5/index.module.css'
import cssfileheadertheme7 from '../../common/components/header/theme7/index.module.css'
import cssfileheadertheme8 from '../../common/components/header/theme8/index.module.css'
import cssfileheadertheme9 from '../../common/components/header/theme9/index.module.css'
import cssfileheadertheme10 from '../../common/components/header/theme10/index.module.css'
import cssfileheadertheme11 from '../../common/components/header/theme11/index.module.css'
import cssfileheadertheme12 from '../../common/components/header/theme12/index.module.css'
import cssfileheadertheme13 from '../../common/components/header/theme13/index.module.css'

import cssfilemobileheader from '../../common/components/mobileHeader/theme1/index.module.css'
import cssfilemobileheadertheme2 from '../../common/components/mobileHeader/theme2/index.module.css'
import cssfilemobileheadertheme4 from '../../common/components/mobileHeader/theme4/index.module.css'
import cssfilemobileheadertheme5 from '../../common/components/mobileHeader/theme5/index.module.css'
import cssfilemobileheadertheme7 from '../../common/components/mobileHeader/theme7/index.module.css'
import cssfilemobileheadertheme8 from '../../common/components/mobileHeader/theme8/index.module.css'
import cssfilemobileheadertheme9 from '../../common/components/mobileHeader/theme9/index.module.css'
import cssfilemobileheadertheme10 from '../../common/components/mobileHeader/theme10/index.module.css'
import cssfilemobileheadertheme11 from '../../common/components/mobileHeader/theme11/index.module.css'
import cssfilemobileheadertheme12 from '../../common/components/mobileHeader/theme12/index.module.css'
import cssfilemobileheadertheme13 from '../../common/components/mobileHeader/theme13/index.module.css'

import cssfilemobilesubfooter from '../../common/components/mobileSubFooter/MobileSubFooter1/index.module.css'
import cssfilemobilesubheader from '../../common/components/mobileSubHeader/mobileSubHeader1/index.module.css'
import loginB2B from '../../common/lib/auth/b2bauth'
import logincss from '../../common/components/login/Theme1/theme1/index.module.css'
import logincssTheme4 from '../../common/components/login/Theme4/theme1/index.module.css'
import logincssTheme5 from '../../common/components/login/Theme5/theme1/index.module.css'
import logincssTheme7 from '../../common/components/login/theme7/index.module.css'
import logincssTheme13 from '../../common/components/login/theme13/index.module.css'

import registercssTheme11 from '../../common/components/login/Theme11/Registration/register.module.css'
import registercssTheme12 from '../../common/components/login/Theme12/Registration/register.module.css'

import loginfilecssTheme11 from '../../common/components/login/Theme11/login/login.module.css'
import vendorfilecssTheme11 from '../../common/components/login/Theme11/venderLogin/vendor.module.css'
import menucssfile from '../components/Menu/index.module.css'
import menucssfileTheme4 from '../components/Menu/theme4/index.module.css'
import menucssfileTheme5 from '../components/Menu/theme5/index.module.css'
import menucssfileTheme10 from '../components/Menu/theme10/index.module.css'
import menucssfileTheme13 from '../components/Menu/theme13/index.module.css'
import mobileCountrystyles from '../../common/components/CountryDropdown/theme1/mobindex.module.css'
import mobileISDstyles from '../../common/components/IsdCountryDropdown/theme1/mobindex.module.css'
import mobileISDstylesTheme5 from '../../common/components/IsdCountryDropdown/theme5/mobindex.module.css'
import mobileISDstylesTheme7 from '../../common/components/IsdCountryDropdown/theme7/mobindex.module.css'
import mobileISDstylesTheme13 from '../../common/components/IsdCountryDropdown/theme13/mobindex.module.css'

import mobilelogincss from '../../common/components/login/Mobile/theme1/index.module.css'
import mobilelogincssTheme5 from '../../common/components/login/Mobile/theme5/index.module.css'
import mobilelogincssTheme13 from '../../common/components/login/Mobile/theme13/index.module.css'
import modalCss from '../../common/components/ModalPopupComponent/index.module.css'
import modalCssTheme5 from '../../common/components/ModalPopupComponent/theme5/index.module.css'
import modalCssTheme7 from '../../common/components/ModalPopupComponent/theme7/index.module.css'
import modalCssTheme11 from '../../common/components/ModalPopupComponent/theme11/index.module.css'
import modalCssTheme12 from '../../common/componentsV2/modalPopUp/themeCss/theme12.module.css'

import modalCssTheme8 from '../../common/components/ModalPopupComponent/theme8/index.module.css'
import PageSeo from '../../common/PageSeo'
import siteMetadata from '@/data/siteMetadata'
import { useRouter } from 'next/router'
import googleTransalationCss from '../components/googleTranslate/index.module.css'
import GoogleTranslate from '../../common/components/googleTranslate/custom'
import IsdCodeDropdownCss from '@/commonComponents/IsdCodeDropdown/index.module.css'
import ModalCssMobile from '@/commonComponents/ModalPopupComponent/theme5mobile/index.module.css'
import NotificationBarStyles from '../../common/components/notificationBar/theme8/index.module.css'
import MobFooterNavbar from '../../common/components/MobFooterNavbar/index'
import MobFooterNavbarStyles from '../../common/components/MobFooterNavbar/theme8/index.module.css'
import MobFooterNavbarStylesTheme11 from '../../common/components/MobFooterNavbar/theme11/index.module.css'
import ManageBooking from '../../common/components/ManageBooking/index'
import ManageBookingStyles8 from '../../common/components/ManageBooking/theme8/index.module.css'
import ManageBookingStyles12 from '../../common/components/ManageBooking/theme12/index.module.css'

import { fetchClientInfo } from '../../common/lib/fingerprintjs'
import { getAlertInfo } from '@/lib/getAlertInfo'
import dropdownStyles from '../../common/components/pageBreakup/Dropdown/theme11/index.module.css'
import dropdownStylesTheme12 from '../../common/components/pageBreakup/Dropdown/theme12/index.module.css'
import titledropdownStylesTheme12 from '../../common/components/pageBreakup/Dropdown/theme12/title.module.css'

import titledropdownStyles from '../../common/components/pageBreakup/Dropdown/theme11/title.module.css'
import isdDropdownStyles from '../../common/components/pageBreakup/IsdDropDown/theme11/index1.module.css'
import isdDropdownStyles12 from '../../common/components/pageBreakup/IsdDropDown/theme12/index1.module.css'
import basiccss from '../../common/components/login/Theme11/index.module.css'
import basiccss12 from '../../common/components/login/Theme12/index.module.css'

import PromotionBanner from '../../common/components/carousel/theme11/index'
import PromotionBannerCss from '../../common/components/carousel/theme11/index.module.css'
import datepicker from '../../common/components/login/Theme11/Registration/datepicker.module.css'

const LayoutWrapper = ({ children, sessionData }) => {
  // console.log('=======LayoutWrapper shared children.props===', children.props)

  // console.log(children.props.theme)

  const [state, setState] = useState({
    headerPopup: false,
    popupType: '',
    emailid: '',
    user: {},
    isLoggedIn: false,
    isLoading: true,
  })
  const [assistedBokingPopup, setAssistedBokingPopup] = useState(false)
  const [assistedBookingData, setAssistedBookingData] = useState({})
  const [manageBokingPopup, setManageBokingPopup] = useState(false)
  const [newsAlert, setNewsAlert] = useState([])
  const router = useRouter()
  let routerurl = ['/quotation', '/page/[index]'] //not required login
  let restrctedUrl = ['/signin']
  const urls = [
    '/signin',
    '/myprofile',
    '/page/[index]',
    '/',
    '/[index]',
    '/hotels',
    '/hotel',
    '/flight',
    '/flights',
    '/activities',
    '/holiday',
    '/holidays',
    '/experiences',
    '/offline',
    '/voucher',
    '/visa',
    '/insurance',
  ]
  const isValidUrl = urls.includes(router.pathname)
  // console.log("router.pathname",router);
  const urlValue = router.pathname == '/' ? 'holidays' : router.query.index

  // Common SSO redirect handler
  function handleSSORedirect(ssoConfig, login = false) {
    if (ssoConfig?.status) {
      if (ssoConfig.required && !login) {
        // Redirect to parent_url if SSO is required
        if (ssoConfig?.parent_url) {
          window.location.href = ssoConfig.parent_url
          return true
        }
      } else if (login) {
        // Redirect to login_url if SSO is enabled but not required, append current url
        const currentUrl = window.location.href
        let loginUrl = ssoConfig.login_url
        // Add current URL as a redirect param (use ? or & as needed)
        const encodedCurrentUrl = btoa(unescape(encodeURIComponent(currentUrl)));
        loginUrl = loginUrl + encodedCurrentUrl;
        window.location.href = loginUrl;
        return true;
      }
    }
    return false
  }

  useEffect(() => {
    //appType in localStorage
    if (!localStorage.getItem('appType') && router.query && router.query.appType == 'mobileapp') {
      localStorage.setItem('appType', 'mobileapp')
    }

    //nativeView in localStorage
    if (
      !localStorage.getItem('nativeView') &&
      router?.query &&
      router?.query?.nativeview == 'true'
    ) {
      localStorage.setItem('nativeView', 'true')
    }

    //deviceType in localStorage
    var device_type = 'Desktop'
    if (children?.props?.isMobile) {
      device_type =
        localStorage.getItem('appType') || localStorage.getItem('nativeView')
          ? 'MobileApp'
          : 'Mobile'
    }
    if (device_type != localStorage.getItem('deviceType')) {
      localStorage.setItem('deviceType', device_type)
    }

    //deviceId in localStorage
    //if (!localStorage.getItem('deviceId')) {
    const fetchData = async () => {
      const clientData = await fetchClientInfo()
      const deviceId = clientData?.deviceId || ''
      localStorage.setItem('deviceId', deviceId)
      localStorage.setItem('clientData', JSON.stringify(clientData))
    }
    fetchData()
    //}

    // added custom css from mo
    if (children?.props?.home?.data?.data?.css) {
      const style = document.createElement('style')
      style.innerHTML = children?.props?.home?.data?.data?.css
      document.head.appendChild(style)
    }

    //check sessionData
    //console.log('==sessionData=', sessionData)
    // if (sessionData) {
    //   //console.log('==sessionData exist=')
    //   setState((prevState) => {
    //     return {
    //       ...prevState,
    //       user: {
    //         ...sessionData,
    //         userType: sessionData.type,
    //       },
    //       isLoggedIn: true,
    //       isLoading: false,
    //     }
    //   })

    //   // restrict user after login
    //   if (restrctedUrl.includes(router.pathname)) {
    //     cf.redirectTo('/')
    //   }
    // } else {
    //   //console.log('==sessionData not exist=')
    //   if (children?.props?.home?.data?.site?.business_b2b) {
    //     // if (routerurl.indexOf(router.pathname) == -1) {
    //     //   loginB2B(children)
    //     // }
    //     if (!routerurl.includes(router.pathname)) {
    //       loginB2B(children)
    //     }
    //   }
    //   setState((prevState) => {
    //     return {
    //       ...prevState,
    //       user: {},
    //       isLoading: false,
    //     }
    //   })
    // }

    checksessionAPI()

    //verificationtoken
    if (
      router.query &&
      router.query.verificationtoken &&
      router.query.verificationtoken !== '' &&
      router.query.verificationtoken !== null
    ) {
      let requestData = {
        registraion_token: router.query.verificationtoken,
      }
      checkregistertoken(requestData).then((res) => {
        console.log('registration token res', res)
        if (res?.status && res?.registraion_token_status) {
          setState((prevState) => {
            return {
              ...prevState,
              emailid: res?.email || '',
              headerPopup: true,
              popupType: 'SignUp',
            }
          })
        }
      })
    }
    const { query } = router || {}

    const token = query?.resettoken || query?.createtoken
    if (token) {
      setState((prevState) => {
        return {
          ...prevState,
          headerPopup: true,
          popupType: 'ChangePassword',
        }
      })
    }

    getAlertInfo()
      .then((res) => {
        if (res?.status) {
          setNewsAlert(res?.data?.data)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }, [urlValue])

  useEffect(() => {
    if (state.headerPopup) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [state.headerPopup])

  const HideHeaderTheme2 = useContext(HideHeader)
  const themeType = children?.props?.home?.data?.site?.site_theme

  const hideMobFooter =
    themeType == 'theme9' || ('theme11' && children?.props?.isMobile && router.pathname == '/login')
  //Header Footer show/hide
  const seoPageData = children.props?.seoPagesData ? children.props?.seoPagesData : null
  var isSeoPageFooter = children.props?.seoPagesData
    ? children.props?.seoPagesData?.show_footer
    : true

  if (themeType == 'theme5' || themeType == 'theme13') {
    isSeoPageFooter = true
  }

  if (themeType == 'theme4' && window.location.pathname == '/login') {
    isSeoPageFooter = false
  }

  if (themeType == 'theme10' && window.location.pathname == '/login') {
    isSeoPageFooter = false
  }

  // handle header ====>

  var isSeoPageHeader = true

  if (children.props?.seoPagesData) {
    isSeoPageHeader = children.props?.seoPagesData?.show_header == false ? false : true
  } else {
    if (children?.props?.isMobile) {
      isSeoPageHeader =
        children?.props?.home?.data?.data?.header?.mobile?.is_show_header == false ? false : true
    } else {
      isSeoPageHeader =
        children?.props?.home?.data?.data?.header?.is_show_header == false ? false : true
    }
  }

  const handleDataReceived = (data) => {
    if (data) {
      setAssistedBookingData(data)
      setAssistedBokingPopup(true)
    }

    // Do something with the received data in the parent component
  }

  const handleManageBooking = (val) => {
    setManageBokingPopup(val)
  }
  const checksessionAPI = () => {
    checksession()
      .then((response) => {
        if (response.status) {
          setState((prevState) => {
            return {
              ...prevState,
              user: {
                ...response,
                userType: response.type,
              },
              isLoggedIn: true,
              isLoading: false,
            }
          })

          // restrict user after login
          if (restrctedUrl.includes(router.pathname)) {
            cf.redirectTo('/')
          }
        } else {
          // Handle SSO redirect for unauthenticated users
          const ssoConfig = children?.props?.home?.data?.site?.sso
          if (handleSSORedirect(ssoConfig)) return

          if (children?.props?.home?.data?.site?.business_b2b) {
            // if (routerurl.indexOf(router.pathname) == -1) {
            //   loginB2B(children)
            // }
            if (!routerurl.includes(router.pathname)) {
              // BYV-5136: when a redirect to /login is in flight, keep isLoading true so the
              // !state.isLoading render gate never paints protected content during navigation
              if (loginB2B(children)) return
            }
          }
          setState((prevState) => {
            return {
              ...prevState,
              user: {},
              isLoading: false,
            }
          })
        }
      })
      .catch((err) => {
        setState((prevState) => {
          return {
            ...prevState,
            user: {},
            isLoading: false,
          }
        })
        console.log(err.msg)
      })
  }
  return (
    <SectionContainer>
      {/* PageSeo */}
      <PageSeo children={children} />
      {children?.props?.home?.data?.site?.allow_multilingual && (
        <GoogleTranslate
          style={googleTransalationCss}
          isMobile={false}
          closeTranslationModal={''}
          isHomePage={false}
        />
      )}
      {!state.isLoading && (
        <AuthContext.Provider
          value={{
            isLoggedIn: state.isLoggedIn,
            user: state.user,
          }}
        >
          {!children.props.isMobile ? (
            window.location.pathname !== '/sso/login' &&
              window.location.pathname !== '/login' &&
              window.location.pathname !== '/quotation' ? (
              <div className="desktop-layoutwrapper shared-offileheader new-homepage">
                {isSeoPageHeader && (
                  <Header
                    theme={themeType}
                    cssfile={
                      themeType == 'theme13'
                        ? cssfileheadertheme13
                        : themeType == 'theme12'
                          ? cssfileheadertheme12
                          : themeType == 'theme11'
                            ? cssfileheadertheme11
                            : themeType == 'theme10'
                              ? cssfileheadertheme10
                              : themeType == 'theme9'
                                ? cssfileheadertheme9
                                : themeType == 'theme8'
                                  ? cssfileheadertheme8
                                  : themeType == 'theme7'
                                    ? cssfileheadertheme7
                                    : themeType == 'theme5'
                                      ? cssfileheadertheme5
                                      : themeType == 'theme4'
                                        ? cssfileheadertheme4
                                        : themeType == 'theme2'
                                          ? cssfileheadertheme2
                                          : cssfileheader
                    }
                    themeType={themeType}
                    HideHeaderTheme2={HideHeaderTheme2}
                    siteData={children?.props?.home?.data}
                    isMobile={children?.props?.isMobile}
                    headermenu={
                      !cf.isValueEmpty(children) &&
                      !cf.isValueEmpty(children.props) &&
                      !cf.isValueEmpty(children.props.home) &&
                      !cf.isValueEmpty(children.props.home.data) &&
                      !cf.isValueEmpty(children.props.home.data.data) &&
                      !cf.isValueEmpty(children.props.home.data.data.header) &&
                      children.props.home.data.data.header
                    }
                    sessionData={!cf.isValueEmpty(sessionData) ? sessionData : ''}
                    site_id={children?.props?.home?.data?.data?.site_id || ''}
                    // onClickHeaderLoginB2C={(data) => {
                    //   cf.redirectTo('/signin', {s: signinvalue})
                    // }}
                    // setSigninvalue={setSigninvalue}
                    onClickHeaderLogin={(popupPage, popupCompoenet) => {
                      const ssoConfig = children?.props?.home?.data?.site?.sso
                      if (handleSSORedirect(ssoConfig, true)) return
                      const resolvedPopupPage = typeof popupPage === 'string' ? popupPage : 'LogIn';
                      setState((prevState) => ({
                        ...prevState,
                        headerPopup: true,
                        // popupType: { popupPage, popupCompoenet },
                        popupType: themeType == 'theme11' ? { popupPage: resolvedPopupPage, popupCompoenet } : resolvedPopupPage,
                      }))
                    }}
                    user={state.user}
                    onDataReceived={handleDataReceived}
                    query={urlValue}
                    showTranslation={true}
                    googleTransalationCss={googleTransalationCss}
                    NotificationBarStyles={NotificationBarStyles}
                    isLoginBtn={themeType == 'theme8' ? false : true}
                    isSupportSection={themeType == 'theme8' ? false : true}
                    isLanguageSection={themeType == 'theme8' ? false : true}
                    isShowLoginsection={themeType == 'theme8' ? false : true}
                    isServiceSection={themeType == 'theme8' ? false : true}
                    isManageBokkingSection={themeType == 'theme8' ? true : false}
                    isShowLogoSection={true}
                    showNotificaitionBar={
                      themeType == 'theme8' && newsAlert?.length > 0 ? true : false
                    }
                    newsAlert={newsAlert}
                    handleManageBooking={handleManageBooking}
                    modalCss={modalCssTheme12}
                  />
                )}

                {manageBokingPopup ? (
                  <ManageBooking
                    styles={themeType == "theme12" ? ManageBookingStyles12 : ManageBookingStyles8}
                    modalCss={themeType == "theme12" ? modalCssTheme12 : modalCssTheme8}
                    verifyCss={themeType == "theme12" ? ManageBookingStyles12 : registercssTheme12}
                    handleManageBooking={handleManageBooking}
                    manageBokingPopup={manageBokingPopup}
                    isMobile={children?.props?.isMobile}
                    siteData={children?.props?.home?.data}
                    theme={children?.props?.home?.data?.site?.site_theme}
                    {...children?.props}
                  />
                ) : null}

                {state.headerPopup ? (
                  <LoginComponent
                    loginTheme={themeType}
                    directOpenLinkPopup={state.popupType}
                    clearDirectOpenLinkPopup={() => {
                      setState((prevState) => {
                        return {
                          ...prevState,
                          popupType: '',
                        }
                      })
                    }}
                    siteData={children?.props?.home?.data}
                    isMobile={children?.props?.isMobile}
                    registrationToken={router.query.verificationtoken}
                    resetToken={router.query.resettoken}
                    logincss={
                      themeType == 'theme13'
                        ? logincssTheme13
                        : themeType === 'theme12'
                          ? {
                            registercssTheme12,
                            dropdownStylesTheme12,
                            isdDropdownStyles12,
                            titledropdownStylesTheme12,
                            basiccss12,
                          }
                          : themeType === 'theme11'
                            ? {
                              registercssTheme11,
                              loginfilecssTheme11,
                              dropdownStyles,
                              vendorfilecssTheme11,
                              titledropdownStyles,
                              isdDropdownStyles,
                              basiccss,
                              PromotionBannerCss,
                              datepicker,
                            }
                            : themeType == 'theme7'
                              ? logincssTheme7
                              : themeType == 'theme5'
                                ? logincssTheme5
                                : themeType == 'theme4'
                                  ? logincssTheme4
                                  : logincss
                    }
                    ISDstyles={
                      themeType == 'theme13'
                        ? ISDstylesTheme5
                        : themeType == 'theme5'
                          ? ISDstylesTheme5
                          : themeType == 'theme7'
                            ? ISDstylesTheme7
                            : ISDstyles
                    }
                    Countrystyles={Countrystyles}
                    setToken={(data) => {
                      setLoginToken(data)
                    }}
                    emailId={state.emailid}
                    modalCss={
                      // themeType == 'theme13'
                      // ? modalCssTheme13
                      themeType == 'theme12'
                        ? modalCssTheme12 :
                        themeType == 'theme11'
                          ? modalCssTheme11
                          : themeType == 'theme7'
                            ? modalCssTheme7
                            : themeType == 'theme5'
                              ? modalCssTheme5
                              : modalCss
                    }
                    onClickCross={() => {
                      setState((prevState) => {
                        return {
                          ...prevState,
                          headerPopup: false,
                        }
                      })
                    }}
                    ModalCssMobile={ModalCssMobile}
                    IsdCodeDropdownCss={IsdCodeDropdownCss}
                  />
                ) : null}

                {assistedBokingPopup ? (
                  <AssistedBooking
                    styles={
                      children?.props?.home?.data?.site?.site_theme == 'theme1'
                        ? AssistedStyles
                        : AssistedStylestwo
                    }
                    data={assistedBookingData}
                    setAssistedBokingPopup={setAssistedBokingPopup}
                    theme={children?.props?.home?.data?.site?.site_theme}
                    isMobile={children?.props?.isMobile}
                    user={state.user}
                  />
                ) : null}

                {children?.props?.home?.data?.site?.site_theme == 'theme2' ? (
                  <main className="">{children}</main>
                ) : (
                  <main className={isSeoPageHeader == false ? '' : 'pt-16'}>{children}</main>
                )}

                {/* Footer section for Theme1 */}

                {/* {<Footer
                theme={children?.props?.home?.data?.site?.site_theme} 
                cssfile={cssfilefooter}
                siteData={children?.props?.home?.data}
                footermenu={
                  !cf.isValueEmpty(children) && !cf.isValueEmpty(children.props)
                  && !cf.isValueEmpty(children.props.home) && !cf.isValueEmpty(children.props.home.data) && !cf.isValueEmpty(children.props.home.data.data) &&
                  !cf.isValueEmpty(children.props.home.data.data.footer) &&
                  children.props.home.data.data.footer
                }
                site_id={children?.props?.home?.data?.data?.site_id || ""}
              />} */}

                {/* Footer section for Theme1 */}

                {isSeoPageFooter && (
                  <Footer
                    theme={themeType}
                    cssfile={
                      themeType == 'theme13'
                        ? cssfilefootertheme13
                        : themeType == 'theme12'
                          ? cssfilefootertheme12
                          : themeType == 'theme11'
                            ? cssfilefootertheme11
                            : themeType == 'theme10'
                              ? cssfilefootertheme10
                              : themeType == 'theme9'
                                ? cssfilefootertheme9
                                : themeType == 'theme8'
                                  ? cssfilefootertheme8
                                  : themeType == 'theme7'
                                    ? cssfilefootertheme7
                                    : themeType == 'theme5'
                                      ? cssfilefootertheme5
                                      : themeType == 'theme4'
                                        ? cssfilefootertheme4
                                        : themeType == 'theme2'
                                          ? cssfilefootertheme2
                                          : cssfilefooter
                    }
                    siteData={children?.props?.home?.data}
                    footermenu={
                      !cf.isValueEmpty(children) &&
                      !cf.isValueEmpty(children.props) &&
                      !cf.isValueEmpty(children.props.home) &&
                      !cf.isValueEmpty(children.props.home.data) &&
                      !cf.isValueEmpty(children.props.home.data.data) &&
                      !cf.isValueEmpty(children.props.home.data.data.footer) &&
                      children.props.home.data.data.footer
                    }
                    site_id={children?.props?.home?.data?.data?.site_id || ''}
                    isMobile={children?.props?.isMobile}
                  />
                )}
              </div>
            ) : (
              <main className="">{children}</main>
            )
          ) : (
            <div className="mobile-layoutwrapper">
              {isSeoPageHeader && window.location.pathname !== '/sso/login' && (
                <MobileHeader
                  handleManageBooking={handleManageBooking}
                  router={router}
                  theme={themeType}
                  cssfile={
                    themeType == 'theme13'
                      ? cssfilemobileheadertheme13
                      : themeType == 'theme12'
                        ? cssfilemobileheadertheme12
                        : themeType == 'theme7'
                          ? cssfilemobileheadertheme7
                          : themeType == 'theme11'
                            ? cssfilemobileheadertheme11
                            : themeType == 'theme10'
                              ? cssfilemobileheadertheme10
                              : themeType == 'theme9'
                                ? cssfilemobileheadertheme9
                                : themeType == 'theme8'
                                  ? cssfilemobileheadertheme8
                                  : themeType == 'theme7'
                                    ? cssfilemobileheadertheme7
                                    : themeType == 'theme5'
                                      ? cssfilemobileheadertheme5
                                      : themeType == 'theme4'
                                        ? cssfilemobileheadertheme4
                                        : themeType == 'theme2'
                                          ? cssfilemobileheadertheme2
                                          : cssfilemobileheader
                  }
                  menucssfile={
                    themeType === 'theme10'
                      ? menucssfileTheme10
                      : themeType === 'theme5'
                        ? menucssfileTheme5
                        : themeType === 'theme4'
                          ? menucssfileTheme4
                          : themeType === 'theme13'
                            ? menucssfileTheme13
                            : menucssfile
                  }
                  siteData={children?.props?.home?.data}
                  headermenu={
                    !cf.isValueEmpty(children) &&
                    !cf.isValueEmpty(children.props) &&
                    !cf.isValueEmpty(children.props.home) &&
                    !cf.isValueEmpty(children.props.home.data) &&
                    !cf.isValueEmpty(children.props.home.data.data) &&
                    !cf.isValueEmpty(children.props.home.data.data.header) &&
                    children.props.home.data.data.header
                  }
                  site_id={children?.props?.home?.data?.data?.site_id || ''}
                  onClickHeaderLogin={(popupPage, popupCompoenet) => {
                    const ssoConfig = children?.props?.home?.data?.site?.sso
                    if (handleSSORedirect(ssoConfig, true)) return
                    const resolvedPopupPage = typeof popupPage === 'string' ? popupPage : 'LogIn';
                    setState((prevState) => ({
                      ...prevState,
                      headerPopup: true,
                      // popupType: { popupPage, popupCompoenet },
                      popupType: themeType == 'theme11' ? { popupPage: resolvedPopupPage, popupCompoenet } : resolvedPopupPage,
                    }))
                  }}
                  onClickHeaderLoginB2C={(data) => {
                    cf.redirectTo('/signin')
                  }}
                  pathname={router.pathname}
                  user={state.user}
                  assistedcss={AssistedMobile}
                  isMobile={children?.props?.isMobile}
                  modalCss={modalCssTheme5}
                  googleTransalationCss={googleTransalationCss}
                  showTranslation={true}
                  NotificationBarStyles={NotificationBarStyles}
                  showNotificaitionBar={
                    themeType == 'theme8' && newsAlert?.length > 0 ? true : false
                  }
                  newsAlert={newsAlert}
                />
              )}
              {/* <MobileSubHeader
            theme="theme1"
            cssfile={cssfilemobilesubheader}
            headermenu={
              !cf.isValueEmpty(children) && !cf.isValueEmpty(children.props)
              && !cf.isValueEmpty(children.props.home) && !cf.isValueEmpty(children.props.home.data) && !cf.isValueEmpty(children.props.home.data.data) &&
              !cf.isValueEmpty(children.props.home.data.data.header) &&
              children.props.home.data.data.header
            }
          /> */}

              {state.headerPopup && window.location.pathname !== '/login' ? (
                <LoginComponent
                  loginTheme={themeType}
                  isMobile={true}
                  directOpenLinkPopup={state.popupType}
                  clearDirectOpenLinkPopup={() => {
                    setState((prevState) => {
                      return {
                        ...prevState,
                        popupType: '',
                      }
                    })
                  }}
                  siteData={children.props.home.data}
                  registrationToken={router.query.verificationtoken}
                  resetToken={router.query.resettoken}
                  logincss={
                    themeType == 'theme13'
                      ? logincssTheme13
                      : themeType === 'theme12'
                        ? {
                          registercssTheme12,
                          dropdownStylesTheme12,
                          isdDropdownStyles12,
                          titledropdownStylesTheme12,
                          basiccss12,
                        }
                        : themeType === 'theme11'
                          ? {
                            registercssTheme11,
                            loginfilecssTheme11,
                            vendorfilecssTheme11,
                            dropdownStyles,
                            titledropdownStyles,
                            isdDropdownStyles,
                            basiccss,
                            PromotionBannerCss,
                          }
                          : themeType === 'theme12'
                            ? {
                              registercssTheme12,
                              dropdownStylesTheme12,
                              isdDropdownStyles12,
                              titledropdownStylesTheme12,
                              basiccss12,
                            }
                            : themeType == 'theme7'
                              ? logincssTheme7
                              : themeType == 'theme5'
                                ? logincssTheme5
                                : themeType == 'theme4'
                                  ? logincssTheme4
                                  : logincss
                  }
                  ISDstyles={
                    themeType == 'theme13'
                      ? mobileISDstylesTheme13
                      : themeType == 'theme5'
                        ? mobileISDstylesTheme5
                        : themeType == 'theme7'
                          ? mobileISDstylesTheme7
                          : mobileISDstyles
                  }
                  Countrystyles={mobileCountrystyles}
                  setToken={(data) => {
                    setLoginToken(data)
                  }}
                  emailId={state.emailid}
                  modalCss={
                    // children?.props?.home?.data?.site?.site_theme == 'theme13'
                    //   ? modalCssTheme13
                    //   :
                    children?.props?.home?.data?.site?.site_theme == 'theme7'
                      ? modalCssTheme7
                      : children?.props?.home?.data?.site?.site_theme == 'theme5'
                        ? modalCssTheme5
                        : children?.props?.home?.data?.site?.site_theme == 'theme12'
                          ? modalCssTheme12
                          : modalCss
                  }
                  onClickCross={() => {
                    setState((prevState) => {
                      return {
                        ...prevState,
                        headerPopup: false,
                      }
                    })
                  }}
                  ModalCssMobile={ModalCssMobile}
                  IsdCodeDropdownCss={IsdCodeDropdownCss}
                />
              ) : null}

              {themeType == 'theme5' || themeType == 'theme9' || themeType == 'theme13' ? (
                <main className="">{children}</main>
              ) : (
                <main className={isSeoPageHeader == false ? '' : 'pt-16'}>{children}</main>
              )}

              {!hideMobFooter && isSeoPageFooter && (
                <Footer
                  theme={themeType}
                  cssfile={
                    themeType == 'theme13'
                      ? cssfilefootertheme13
                      : themeType == 'theme12'
                        ? cssfilefootertheme12
                        : themeType == 'theme11'
                          ? cssfilefootertheme11
                          : themeType == 'theme10'
                            ? cssfilefootertheme10
                            : themeType == 'theme9'
                              ? cssfilefootertheme9
                              : themeType == 'theme8'
                                ? cssfilefootertheme8
                                : themeType == 'theme7'
                                  ? cssfilefootertheme7
                                  : themeType == 'theme5'
                                    ? cssfilefootertheme5
                                    : themeType == 'theme4'
                                      ? cssfilefootertheme4
                                      : themeType == 'theme2'
                                        ? cssfilefootertheme2
                                        : cssfilefooter
                  }
                  siteData={children?.props?.home?.data}
                  footermenu={
                    !cf.isValueEmpty(children) &&
                    !cf.isValueEmpty(children.props) &&
                    !cf.isValueEmpty(children.props.home) &&
                    !cf.isValueEmpty(children.props.home.data) &&
                    !cf.isValueEmpty(children.props.home.data.data) &&
                    !cf.isValueEmpty(children.props.home.data.data.footer) &&
                    children.props.home.data.data.footer
                  }
                  site_id={children?.props?.home?.data?.data?.site_id || ''}
                  isMobile={children?.props?.isMobile}
                />
              )}

              {themeType == 'theme8' ||
                (themeType == 'theme11' && (
                  <MobFooterNavbar
                    styles={[MobFooterNavbarStyles, MobFooterNavbarStylesTheme11]}
                    theme={themeType === 'theme8' ? 'theme8' : 'theme11'}
                    isMobile={children?.props?.isMobile}
                    user={state.user}
                    handleManageBooking={handleManageBooking}
                  />
                ))}
              {manageBokingPopup ? (
                <ManageBooking
                  styles={themeType == "theme12" ? ManageBookingStyles12 : ManageBookingStyles8}
                  modalCss={themeType == "theme12" ? modalCssTheme12 : modalCssTheme8}
                  verifyCss={themeType == "theme12" && registercssTheme12}
                  handleManageBooking={handleManageBooking}
                  manageBokingPopup={manageBokingPopup}
                  isMobile={children?.props?.isMobile}
                  siteData={children?.props?.home?.data}
                  theme={children?.props?.home?.data?.site?.site_theme}
                />
              ) : null}
              {/* <MobileSubFooter
                theme="theme1"
                cssfile={cssfilemobilesubfooter}
                footermenu={
                  !cf.isValueEmpty(children) && !cf.isValueEmpty(children.props)
                  && !cf.isValueEmpty(children.props.home) && !cf.isValueEmpty(children.props.home.data) && !cf.isValueEmpty(children.props.home.data.data) &&
                  !cf.isValueEmpty(children.props.home.data.data.footer) &&
                  children.props.home.data.data.footer
                }
              /> */}
              {/* <MobileFooter
            theme="theme1"
            cssfile={cssfilemobilefooter}
            footermenu={
              !cf.isValueEmpty(children) && !cf.isValueEmpty(children.props)
              && !cf.isValueEmpty(children.props.home) && !cf.isValueEmpty(children.props.home.data) && !cf.isValueEmpty(children.props.home.data.data) &&
              !cf.isValueEmpty(children.props.home.data.data.footer) &&
              children.props.home.data.data.footer
            }
          /> */}
            </div>
          )}
        </AuthContext.Provider>
      )}
    </SectionContainer>
  )
}

export default LayoutWrapper
